import { useEffect, useState, useMemo, useCallback } from "react";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent, CardFooter } from "src/@/components/ui/card";
import { Textarea } from "src/@/components/ui/textarea";
import useAuth from "src/hooks/useAuth";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";
import { OptionsSelect } from "src/@/components/shared";
import { UploadCampanha } from "src/components/upload";
import MicRecorder from "mic-recorder-to-mp3";
import { CircularProgress, IconButton } from "@mui/material";
import Iconify from "src/components/Iconify";
import RecordingTimer from "src/components/_chats/chat/components/RecordingTimer";
import v2_actionUploadS3 from "src/actions/v2/global/actionUploadS3";
import { FileListItem } from "src/@/components/shared/FileListItem";
import { FileListItemItemText } from "src/@/components/shared/FileListItemItemText";
import UploadAutomacoes from "src/components/upload/UploadAutomacoes";



const CardSendMessage = ({ block, changeBlock }) => {
  const { cliente } = useAuth();
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [messageContent, setMessageContent] = useState("");
  const [canais, setCanais] = useState([]);

  const [typeMessage, setTypeMessage] = useState("text");
  const [recording, setRecording] = useState(false);
  const [audioGravado, setAudioGravado] = useState(null);
  const recorder = useMemo(() => new MicRecorder({ bitRate: 128 }), []);
  const [loadingAudio, setLoadingAudio] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditFile, setIsEditFile] = useState(false);
  //upload
  const [files, setFiles] = useState([]);
  const filesUrl = []
  // eslint-disable-next-line no-unused-vars
  const [filesEdit, setFilesEdit] = useState(block?.data?.chatFiles || []);
  const [loadingEnviarArquivos, setLoadingEnviarArquivos] = useState(false);

  const optionsMessage = [
    { value: "text", label: "Texto", icon: "lets-icons:message-duotone" }, // Substituir ícones por SVGs reais
    { value: "file", label: "Arquivo", icon: "solar:file-linear" },
    { value: "audio", label: "Audio", icon: "mingcute:voice-fill" },
    { value: "image", label: "Imagem", icon: "material-symbols:image-outline" },
  ];


  const buscarListaCanais = async () => {
    try {
      const response = await actionListaCanaisPorCliente(cliente._id)
      setCanais(response.data.data)
    } catch (error) {
      console.log(error)
    }
  }


  const handleDropMultiFile = useCallback(
    async (acceptedFiles) => {

      try {
        const response = await uploadAndGetUrl(acceptedFiles);
        let event = {
          name: "chatFiles",
          value: response
        }
        changeBlock(event)
      } catch (error) {
        console.log('erro ao fazer upload do arquivo:', error)
      }
      setFiles(acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })));

    },
    [setFiles]
  );

  const handleRemove = (file) => {
    console.log('file delete', file);
    console.log('block?.data?.block?.chatFiles', block?.data?.chatFiles);

    let filesBlock = block?.data?.chatFiles || [];
    const filteredItems = filesBlock.filter((_file) => _file.key !== file.key);
    console.log('filteredItems', filteredItems);

    let event = {
      name: "chatFiles",
      action: "delete",
      value: filteredItems
    };

    changeBlock(event);
    setFiles(filteredItems);
};


  const handleRemoveEdit = (file) => {
    const filteredItems = filesEdit.filter((_file) => _file !== file);
    setIsEditFile(false);
    setFilesEdit(filteredItems);
  };


  const handleStartRecording = async () => {
    setLoadingAudio(true);
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await recorder.start();
      setRecording(true);
      setLoadingAudio(false);
    } catch (err) {
      console.log(err);
      setLoadingAudio(false);
    }
  };

  async function pararGravacao() {
    try {
      const [buffer, blob] = await recorder.stop().getMp3()
      const file = new File(buffer, "audio.mp3", {
        type: blob.type,
        lastModified: Date.now()
      });
      setAudioGravado(file)
      setRecording(false)
      const audioUpload = await uploadAudioAndGetUrl(file);
      if (audioUpload) {
        let event = {
          name: "chatAudioMessage",
          value: audioUpload
        }
        changeBlock(event)
      }
    } catch (error) {
      filesUrl = [];
    }

  }

  async function uploadAndGetUrl(files) {
    let filesUrlPush = [];
    if (files.length > 0) {
      for (let file of files) {
        var formData = new FormData();
        var imagefile = file;
        var filename = file.name;
        formData.append("file", imagefile);
        formData.append("filename", filename);

        try {
          let querys = `?path=plataforma/automacoes/${cliente._id}`;
          const response = await v2_actionUploadS3(formData, querys);
          filesUrlPush.push({
            key: response.data.data.key,
            type: file.type,
            location: response.data.data.location,
            name: file.name
          });
        } catch (error) {
          console.log('Erro ao fazer upload do arquivo:', error);
        }
      }
    }
    // Mova o retorno para fora do loop
    return filesUrlPush;
  }


  async function uploadAudioAndGetUrl(file) {
    if (file) {
      var formData = new FormData();
      var audiofile = file;
      formData.append("file", audiofile);
      try {
        let querys = `?path=plataforma/automacoes`
        const response = await v2_actionUploadS3(formData, querys)
        if (!response.data.error) {
          return { key: response.data.data.key, type: file.type, tipo: "audio", location: response.data.data.location };
        }
      } catch (error) {
        console.log('erro ao upload arquivo', error)
      }


    }
  }

  const handleCancelAudio = async () => {
    try {
      await recorder.stop().getMp3();
      setRecording(false);
      setAudioGravado(null);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    buscarListaCanais()
  }, [])

  console.log('block?.data?.block?.chatFiles', block?.data?.chatFiles)



  return (
    <div className="w-full">
      <div className="space-y-4 flex flex-col gap-4">
        {/* Canal de envio */}
        <div>
          <label className="block text-sm font-medium">Canal de Envio</label>
          <Select
            value={block?.data?.chatChannel}
            onValueChange={e => {
              let event = {
                name: "chatChannel",
                value: e
              }
              changeBlock(event)
            }}
            className="w-full"
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Selecione um canal" />
            </SelectTrigger>
            <SelectContent>
              {canais.map((channel) => (
                <SelectItem key={channel._id} value={channel._id}>
                  {channel.nome}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        {block?.data?.chatChannel && (
          <div className="flex flex-col gap-4">
            {/* Mensagem */}
            <OptionsSelect
              title="Tipo de mensagem"
              options={optionsMessage}
              value={block?.data?.chatTypeMessage}
              changeValue={(e) => {
                let event = {
                  name: "chatTypeMessage",
                  value: e,
                }
                changeBlock(event)
              }}
            />

            {block?.data?.chatTypeMessage === "image" && (
              <UploadAutomacoes
                loadingEnviarArquivos={loadingEnviarArquivos}
                showPreview={false}
                files={files}
                isEdit={isEdit}
                isEditFile={isEditFile}
                filesEdit={filesEdit}
                onRemoveEdit={handleRemoveEdit}
                onDrop={handleDropMultiFile}
                onRemove={handleRemove}

              />
            )}

            {block?.data?.chatTypeMessage === "file" && (
              <div>
                <UploadAutomacoes
                  loadingEnviarArquivos={loadingEnviarArquivos}
                  showPreview={false}
                  files={files}
                  isEdit={isEdit}
                  isEditFile={isEditFile}
                  filesEdit={filesEdit}
                  onRemoveEdit={handleRemoveEdit}
                  onDrop={handleDropMultiFile}
                  onRemove={handleRemove}

                />
                {block?.data?.chatFiles?.map((file, index) => (
                  <div key={index} className="flex flex-col gap-2 mt-4">
                   <FileListItemItemText 
                      key={index}
                      file={file}
                      name={file.name}
                      onRemove={handleRemove}
                    />
                  </div>
                ))}
              </div>
            )}

            {block?.data?.chatTypeMessage === "audio" && (
              <div className="mt-4">
                {recording ? (
                  <div className="flex flex-col gap-2">
                    <div className="flex flex-row items-center gap-2">
                      <p>
                        Gravação em andamento
                      </p>
                      <CircularProgress size={15} />
                    </div>
                    <div className="flex flex-row gap-2">
                      <IconButton
                        aria-label="cancelRecording"
                        component="span"
                        fontSize="large"
                        disabled={loadingAudio}
                        onClick={handleCancelAudio}
                      >
                        <Iconify icon="mdi:cancel" />
                      </IconButton>
                      {loadingAudio ? (
                        <div>
                          <CircularProgress />
                        </div>
                      ) : (
                        <RecordingTimer />
                      )}

                      <IconButton
                        aria-label="sendRecordedAudio"
                        component="span"
                        onClick={pararGravacao}
                        disabled={loadingAudio}
                      >
                        <Iconify icon="mdi:send" />
                      </IconButton>
                    </div>

                  </div>
                ) : (
                  <div className="flex flex-row gap-2">

                    {!audioGravado && (
                      <Button
                        disabled={loadingAudio}
                        onClick={handleStartRecording}
                        className="flex flex-row items-center gap-2"
                      >
                        <Iconify icon="mdi:microphone" />
                        Gravar audio
                      </Button>
                    )}

                    {block?.data?.chatAudioMessage && (
                      <div className="flex flex-row gap-2 items-center">
                        {block?.data?.chatAudioMessage?.location ? (
                          <audio controls>
                            <source src={block?.data?.chatAudioMessage?.location} type="audio/mp3" />
                            Seu navegador não suporta a reprodução de áudio.
                          </audio>
                        ) : (
                          <p>erro</p>
                        )}

                        <IconButton onClick={() => setAudioGravado(null)} variant='outlined' color="error">
                          <Iconify icon="material-symbols:delete" />
                        </IconButton>
                      </div>

                    )}
                  </div>

                )}
              </div>
            )}

            {
              block?.data?.chatTypeMessage === "text" && (
                <div className="mt-4">
                  <label className="block text-sm font-medium">Mensagem</label>
                  <Textarea
                    className="w-full"
                    placeholder="Escreva sua mensagem aqui..."
                    value={block?.data?.chatTextMessage}
                    onChange={(e) => {
                      let event = {
                        name: "chatTextMessage",
                        value: e.target.value,
                      }
                      changeBlock(event)
                    }}
                  />
                </div>
              )
            }

          </div>
        )}

      </div>
    </div>
  );
};

export default CardSendMessage;
